import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const crowdSec = defineConnector({
  identifier: "crowdSec",
  name: "CrowdSec",
  tagLine: "Collaborative security engine",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://cti\\.api\\.crowdsec\\.net/.*",
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to the [CrowdSec console](https://app.crowdsec.net/) and navigate to **Settings › API Keys** to create a new key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "CrowdSec API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://cti.api.crowdsec.net/v2/smoke/1.2.3.4",
  },
});
